<template>
    <div :class="{'downapp': 1,'fix': fixed == 'fixed',none: hide}" ref="appdown">
        <template v-if="isHiscores">
            <div class="download-h5">
                <div class="download-logo-hiscores"></div>
                <div class="download-des">
                    <h4>即嗨比分-足球篮球电竞平台</h4>
                    <p>比分直播|社区互动|数据模型|专家推荐</p>
                </div>
                <span class="download-button"></span>
            </div>
        </template>
        <template v-else>
            <div class="download-h5">
            <div :class="qxpack ? 'download-logoqx' : 'download-logo'"></div>
            <div class="download-des">
                <h4>{{newNameJhty ? '即嗨体育' : '即嗨比分'}}-体育数据资讯社区</h4>
                <p>{{subtitle}}</p>
            </div>
            <span class="download-button"></span>
        </div>
        </template>
        <div :class="{'signup88-packets': true,'none': hide}"></div>
        <div :class="{tipbg:true,none:!downtip}">
            <div :class="{downtip:true}">
              <p>
                点击右上角，<br/> 选择“在浏览器中打开”就能下载啦~
              </p>
            </div>
        </div>
     </div>
</template>

<script>
import { isJHApp, isHiscores, appChangeName, urlQuery } from "../../utils/base"
export default {
    name: "appdown",
    props: ["position"],
    data () {
        return {
            hide: true,
            fixed: "fixed",
            isHiscores: false,
            qxpack: false,
            downtip: false,
            // subtitle: "比分直播|社区互动|数据模型|专家推荐",title：足球篮球电竞平台
            subtitle: "涵盖足球、篮球等各项体育赛事",
            newNameJhty: 0
        }
    },
    mounted () {
        this.Init()
    },
    methods: {
        Init () {
            // 在初始化渲染的时候调用。
            const reffer = urlQuery("src");
            if (reffer && (reffer.indexOf('ios_jh_testing') > -1 || reffer.indexOf('android_JH_112') > -1)) {
                this.qxpack = true
            }
            if (!isJHApp()) {
                this.hide = false
                this.fixed = this.position || 'fixed'
                this.subtitle = this.subtitle || '涵盖足球、篮球等各项体育赛事'
                if (!this.position) {
                    var Theight = document.getElementById("t_h");
                    if (Theight) {
                        Theight.className = "t_h ";
                    }
                }
            }
            this.isHiscores = isHiscores()
            if (appChangeName()) {
                this.newNameJhty = 1
            }
        }
    }
}
</script>
